module.exports = __webpack_public_path__ + "static/media/icon-menu-down-end.a12061a9.svg";